import * as React from 'react';
import { Layers } from 'lucide-react';
import { MultiSelect } from '@/components/forms/MultiSelect';
import { Select } from '@/components/forms/Select';
import { Textarea } from '@/components/forms/Textarea';
import { useSessionFormData } from '@/hooks/useSessionFormData';
import { toIdLabelOptions } from '@/components/events/event-form-utils';
import { EVENT_FORMAT_LOCKED, EVENT_FORMAT_OPTIONS } from '@/components/events/event-configs';
import type { EventFormFieldChange, EventFormState } from '@/types/event.types';

/** Props for {@link EventFormatSection}. */
interface Props {
  form: EventFormState;
  onFieldChange: EventFormFieldChange;
}

/** In-person / remote format fields. */
export function EventFormatSection({ form, onFieldChange }: Readonly<Props>) {
  const { levels } = useSessionFormData();
  const levelOptions = toIdLabelOptions(
    levels as Array<{ id: string; label: string }>,
    (level) => level.label,
  );

  function handleFormatChange(value: string): void {
    onFieldChange('eventFormat', value);
  }
  function handleLevelChange(values: string[]): void {
    onFieldChange('levelIds', values);
  }
  function handleNotesChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
    onFieldChange('internalNotes', e.target.value);
  }

  return (
    <>
      <div className="form-section">
        <h4 className="form-section-title">
          <Layers className="w-4 h-4" />
          Format et niveaux
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Format"
            placeholder="Sélectionner un format"
            options={[...EVENT_FORMAT_OPTIONS]}
            value={form.eventFormat || EVENT_FORMAT_LOCKED}
            onChange={handleFormatChange}
            required
            disabled
            size="sm"
          />
          <MultiSelect
            label="Niveaux"
            placeholder="Sélectionner des niveaux"
            options={levelOptions}
            value={form.levelIds || []}
            onChange={handleLevelChange}
            inputSize="sm"
          />
        </div>
      </div>
      <div className="form-section">
        <h4 className="form-section-title">Notes internes</h4>
        <Textarea
          label="Notes"
          placeholder="Notes internes (non visibles par les participants)"
          value={form.internalNotes || ''}
          onChange={handleNotesChange}
          rows={4}
        />
      </div>
    </>
  );
}
